<template>
  <div>
    <a-modal
        v-drag-modal
        wrap-class-name="custom-modal-wrap" v-model="localVisible" :confirmLoading="loading" :maskClosable="false"
        :ok-button-props="{ props: { disabled: !innerForm.id && (suffixLoading || Boolean(suffixError)) } }"
        @cancel="cancel" @ok="confirm"
>
      <div slot="title">{{ innerForm.id ? '编辑账号' : '新增账号' }}</div>
      <div>
        <a-form-model ref="form" :model="innerForm" :rules="formRules" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="username" label="用户名">
            <a-input
              v-model="innerForm.username"
              :disabled="Boolean(innerForm.id)"
              :placeholder="innerForm.id ? '' : '请输入用户名主体'"
            >
              <span v-if="!innerForm.id" slot="addonAfter">{{ usernameSuffix || '加载中' }}</span>
            </a-input>
            <div v-if="!innerForm.id && suffixError" class="suffix-error">{{ suffixError }}</div>
          </a-form-model-item>
          <a-form-model-item prop="name" label="员工姓名">
            <a-input v-model="innerForm.name" />
          </a-form-model-item>
          <a-form-model-item prop="phone" label="手机号">
            <a-input v-model="innerForm.phone" />
          </a-form-model-item>
          <a-form-model-item prop="email" label="邮箱">
            <a-input v-model="innerForm.email" />
          </a-form-model-item>
          <a-form-model-item prop="sex" label="性别">
            <a-select default-value="man" style="width: 100%" v-model="innerForm.sex">
              <a-select-option value="man"> 男 </a-select-option>
              <a-select-option value="woman"> 女 </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="is_active" label="状态">
            <a-select v-model="innerForm.is_active" style="width: 100%;">
              <a-select-option :value="true">启用</a-select-option>
              <a-select-option :value="false">禁用</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="roles" label="角色">
            <a-select v-model="innerForm.roles" mode="multiple" allowClear style="width: 100%;">
              <a-select-option v-for="item in roleItems" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>

        <div v-if="!innerForm.id" style="color: rgb(255, 77, 79); text-align: center;">
          默认初始密码为: 123456, 登录后请修改密码
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import { userCreate, userUpdate, userUsernameSuffix } from '@/api/account'
  import rules from './rules.js'

  export default {
    name: 'FormModal',
    model: { prop: 'visible', event: 'cancel' },
    props: {
      visible: { type: Boolean, default: false },
      form: { type: Object, default: () => ({}) },
      roleItems: { type: Array, default: () => [] },
    },
    data() {
      return {
        rules,
        loading: false,
        localVisible: this.visible,
        innerForm: this.cloneForm(this.form),
        usernameSuffix: '',
        suffixLoading: false,
        suffixError: '',
      };
    },
    computed: {
      formRules() {
        return {
          ...rules,
          username: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
            { validator: this.validateUsername, trigger: 'blur' },
          ],
        };
      },
    },
    watch: {
      visible(v) {
        this.localVisible = v;
        if (v) {
          this.innerForm = this.cloneForm(this.form);
          if (!this.innerForm.id) this.loadUsernameSuffix();
        }
      },
      form(v) {
        this.innerForm = this.cloneForm(v);
      },
    },
    methods: {
      cloneForm(src) {
        return JSON.parse(JSON.stringify(src || {}));
      },
      validateUsername(rule, value, callback) {
        const base = (value || '').trim();
        if (base.includes('@')) {
          callback(new Error('用户名主体不能包含@'));
          return;
        }
        if (!this.innerForm.id && this.usernameSuffix && Array.from(base + this.usernameSuffix).length > 32) {
          callback(new Error('完整用户名不能超过32个字符'));
          return;
        }
        callback();
      },
      async loadUsernameSuffix() {
        this.suffixLoading = true;
        this.suffixError = '';
        this.usernameSuffix = '';
        try {
          const data = await userUsernameSuffix();
          this.usernameSuffix = data.suffix;
          if (!this.usernameSuffix) throw new Error('后缀为空');
        } catch (error) {
          this.suffixError = '公司用户名后缀加载失败，请检查公司名称';
        } finally {
          this.suffixLoading = false;
        }
      },
      confirm() {
        if (!this.innerForm.id && (this.suffixLoading || this.suffixError || !this.usernameSuffix)) {
          this.$message.error(this.suffixError || '公司用户名后缀正在加载');
          return;
        }
        this.$refs.form.validate(valid => {
          if (!valid) return;
          this.loading = true;
          const payload = { ...this.innerForm };
          if (!payload.id) payload.username = (payload.username || '').trim();
          const func = payload.id ? userUpdate : userCreate;
          func(payload).then(data => {
            this.$message.success(payload.id ? '修改成功' : '新增成功');
            this.$emit(payload.id ? 'update' : 'create', data);
            this.cancel();
          }).finally(() => {
            this.loading = false;
          });
        });
      },
      cancel() {
        this.$emit('cancel', false);
        this.usernameSuffix = '';
        this.suffixError = '';
        this.suffixLoading = false;
        if (this.$refs.form) this.$refs.form.resetFields();
      },
    },
  }
</script>

<style scoped>
.suffix-error {
  color: #ff4d4f;
  line-height: 1.5;
  margin-top: 4px;
}
</style>
